import texts from "./texts"

export const getMenuItems = (user) => {
    const items = []
    const { managedCohorts, groups } = user
    if (groups.lab && managedCohorts.length > 0) {
        items.push({"link": "lab", "text": texts.visitingLab})
    }
    if (managedCohorts.length > 0) {
        items.push({"link": "receive-data-and-support", "text": texts.receiveDataAndSupport})
        items.push({"link": "support", "text": texts.support})
        items.push({"link": "cohorts", "text": texts.cohorts})
        items.push({"link": "calls", "text": texts.callCenter})
    }
    if (groups.dietician) {
        items.push({"link": "foods", "text": texts.foods})
        items.push({"link": "medications", "text": texts.medications})
    }
    if (groups.admin) {
        items.push({"link": "admin", "text": texts.admin})
    }
    return items
}
